var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFillCheck = function SvgFillCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 11",
    fill: "currentColor"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.52,
    width: 9.6,
    height: 9.6,
    rx: 4.8,
    fill: "#2AAC5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61 5.34l1.792 1.788 3.005-3.013",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFillCheck;